import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.heading',
		defaultMessage: 'To export your data from {importType}:',
		description: 'Heading for customised csv guide',
	},
	githubStep1: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.github-step-1',
		defaultMessage: 'Go to a board you want to export and open project view.',
		description: 'Step 1 for github export guide',
	},
	githubStep2: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.github-step-2',
		defaultMessage: 'Select the arrow next to the view name and select <b>Download CSV</b>.',
		description: 'Step 2 for github export guide',
	},
	smartsheetStep1: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.smartsheet-step-1',
		defaultMessage: 'Select <b>File</b> > <b>Export</b> > <b>Export to Microsoft Excel</b>',
		description: 'Step 1 for Smartsheet export guide',
	},
	linearStep1: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.linear-step-1',
		defaultMessage: 'In projects or custom view, select a project.',
		description: 'Step 1 for linear export guide',
	},
	linearStep2: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.linear-step-2',
		defaultMessage: 'Select ⋯ option > <b>Export issues as CSV…</b>.',
		description: 'Step 2 for linear export guide',
	},
	azureDevopsStep1: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.azure-devops-step-1',
		defaultMessage: 'Create a <b>query</b> to filter the work items you would like to export.',
		description: 'Step 1 for Azure devops export guide',
	},
	azureDevopsStep2: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.azure-devops-step-2',
		defaultMessage: 'Open the query.',
		description: 'Step 2 for Azure devops export guide',
	},
	azureDevopsStep3: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.azure-devops-step-3',
		defaultMessage: 'Select ⋯ option > <b>Export to CSV.</b>',
		description: 'Step 3 for Azure devops export guide',
	},
	gitLabStep1: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.git-lab-step-1',
		defaultMessage: 'Go to the project you want to export.',
		description: 'Step 1 GitLab export guide',
	},
	gitLabStep2: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.git-lab-step-2',
		defaultMessage:
			'Select <b>Plan</b> > <b>Issues</b> > <b>Actions</b> (⋮) > <b>Export as CSV</b>.',
		description: 'Step 2 for GitLab export guide',
	},
	gitLabStep3: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.guide.git-lab-step-3',
		defaultMessage: 'Verify if the email address is correct and select <b>Export issues</b>.',
		description: 'Step 3 for GitLab export guide',
	},
});
